import {configSelectors} from '../Config';
import {getUserConfig} from '../Config/configSelectors';


/**
 * @param state {object} Global state
 * @return {object} Domain state
 */
const getDomainState = state => {

    return configSelectors.getUserConfig(state);
};


/**
 * @param state {object} Global state
 * @return {object|null} User
 */
export const getUser = state => {

    return getDomainState(state);
};


/**
 * @param state {object} Global state
 * @return {object} Customer
 */
export const getCustomer = state => {

    return getDomainState(state)
        .customer;
};


/**
 * @param state {object} Global state
 * @return {object} Publication
 */
export const getPublication = state => {

    return getDomainState(state)
        .publication;
};


/**
 * @param state {object} Global state
 * @returns {boolean} True if customer is required to provide payment data
 */
export const isPaymentDataRequired = state => {

    const customer = getCustomer(state);

    return customer.isPaymentDataRequired;
};


/**
 * @param state {object} Global state
 * @returns {boolean} True if customer requires PSP onboarding
 */
export const isPaymentProviderOnboardingRequired = state => {

    const customer = getCustomer(state);

    return customer.isPaymentProviderOnboardingRequired;
};
